import React from 'react';
import {observer} from 'mobx-react';
import {withState} from 'shared/core';
import {BenefitDivisionFormState} from '../state';
import {Submit, Layout, Display, FormLayout, Select2, Input, Panel} from 'components';
import {t} from 'shared/core';
import {FormattedMessage} from 'react-intl';

const BenefitDivisionForm = observer(({uiState}) => {
  const {benefitDivision, backPath, errors} = uiState;

  return (
    <div>
      <Display backPath={backPath} title={t('taxable_benefits.Benefit Division Configuration')} />
      <Layout>
        <Panel>
          <Panel.Header 
            title={benefitDivision.displayName} 
            description={t('taxable_benefits.BENEFIT_DIVISION_CONFIG_DESC')}
           />
          <FormLayout>
            <Select2 value={benefitDivision.premiumSplitType}
              onChange={e => benefitDivision.merge({premiumSplitType: e.target.value})}
              label='taxable_benefits.Premium Split Type'
              errorMessage={errors.premiumSplitType}>
              <option value='amount'>{t('taxable_benefits.Amount')}</option>
              <option value='percentage'>{t('taxable_benefits.Percent')}</option>
            </Select2>
            {benefitDivision.premiumSplitType === 'amount' && 
              <Input value={benefitDivision.premiumSplitAmount}
                onChange={e => benefitDivision.merge({premiumSplitAmount: e.target.value})}
                label='taxable_benefits.Premium Split Amount'
                placeholder='$200.00'
                translatePlaceholder={false}
                helpMessage='taxable_benefits.help_text.premium_split_amount'
                errorMessage={errors.premiumSplitAmount}/>}
            {benefitDivision.premiumSplitType === 'percentage' && 
              <Input value={benefitDivision.premiumSplitPercentage}
                onChange={e => benefitDivision.merge({premiumSplitPercentage: e.target.value})}
                label='taxable_benefits.Premium Split Percentage'
                placeholder='50%'
                translatePlaceholder={false}
                helpMessage='taxable_benefits.help_text.premium_split_percentage'
                errorMessage={errors.premiumSplitPercentage}/>}
          </FormLayout>
          <div className='right-align'>
            <Submit onClick={() => uiState.saveBenefitDivision()}>
              <FormattedMessage id='Save'/>
            </Submit>
          </div>
        </Panel>
      </Layout>
    </div>
  );
});

export default withState(BenefitDivisionForm, BenefitDivisionFormState);
